// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const zh_cn_pmainsrclink3 = /** @type {(inputs: {}) => string} */ () => {
	return `图标源码`
};

const en_pmainsrclink3 = /** @type {(inputs: {}) => string} */ () => {
	return `Source`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "zh-cn" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const pmainsrclink3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pmainsrclink3(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("pmainsrclink3", locale)
	if (locale === "zh-cn") return zh_cn_pmainsrclink3(inputs)
	if (locale === "en") return en_pmainsrclink3(inputs)
	return "pMainSrcLink"
};
export { pmainsrclink3 as "pMainSrcLink" }